<template>
  <header class="header-shadow">
    <div
      class="container container-main pt-[14px] pb-[10px] bg-white flex justify-between"
    >
      <router-link
        :to="{ name: '/home' }"
        class="block xl:mr-[24px] xl:mx-0 xl:shrink-0"
      >
        <figure v-if="theme === 'default'">
          <img
loading="lazy"
            src="/img/logo/logo-green.svg"
            alt="logo"
            class="w-[93px] md:w-[142px]"
          />
        </figure>
        <figure v-else>
          <img
loading="lazy"
            src="/img/logo/logo-kids-mobile.svg"
            alt="logo-mobile"
            class="min-[350px]:w-[260px] w-[121px]"
          />
        </figure>
      </router-link>
      <div v-show="$route.meta.withHeaderNav">
        <CheckoutHeaderNav />
      </div>
    </div>
  </header>
  <main class="main--empty">
    <slot></slot>
  </main>
</template>

<script setup>
import CheckoutHeaderNav from "@/components/checkout/CheckoutHeaderNav.vue";
import {theme} from "@/services/getSiteTheme";
</script>

<style lang="scss" scoped>
.header-shadow {
  @media (min-width: 768px) {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  }
}
</style>
